import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// Custom styled component for elements
const ElementBox = styled(Paper)(({ theme, bgcolor }) => ({
  width: 60,
  height: 60,
  backgroundColor: bgcolor || theme.palette.grey[300],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: 5,
  color: "#000",
  fontWeight: "bold",
}));

// Define periodic table elements with their positions
const elements = [
  // Format: { symbol, row, col, color }
  { symbol: "Li", row: 2, col: 1, color: "#f8a5c2" },
  { symbol: "Be", row: 2, col: 2, color: "#f8a5c2" },
  { symbol: "F", row: 2, col: 17, color: "#fff200" },
  { symbol: "Ne", row: 2, col: 18, color: "#f8a5c2" },

  { symbol: "Na", row: 3, col: 1, color: "#f8a5c2" },
  { symbol: "Mg", row: 3, col: 2, color: "#f8a5c2" },
  { symbol: "Cl", row: 3, col: 17, color: "#fff200" },
  { symbol: "Ar", row: 3, col: 18, color: "#f8a5c2" },

  { symbol: "K", row: 4, col: 1, color: "#f8a5c2" },
  { symbol: "Ca", row: 4, col: 2, color: "#f8a5c2" },
  { symbol: "Sc", row: 4, col: 3, color: "#91caff" },
  { symbol: "Ti", row: 4, col: 4, color: "#91caff" },
  { symbol: "V", row: 4, col: 5, color: "#91caff" },
  { symbol: "Cr", row: 4, col: 6, color: "#91caff" },
  { symbol: "Mn", row: 4, col: 7, color: "#91caff" },
  { symbol: "Fe", row: 4, col: 8, color: "#91caff" },
  { symbol: "Co", row: 4, col: 9, color: "#91caff" },
  { symbol: "Ni", row: 4, col: 10, color: "#91caff" },
  { symbol: "Cu", row: 4, col: 11, color: "#91caff" },
  { symbol: "Zn", row: 4, col: 12, color: "#91caff" },
  { symbol: "Ga", row: 4, col: 13, color: "#fff200" },
  { symbol: "Ge", row: 4, col: 14, color: "#fff200" },
  { symbol: "As", row: 4, col: 15, color: "#fff200" },
  { symbol: "Se", row: 4, col: 16, color: "#fff200" },
  { symbol: "Br", row: 4, col: 17, color: "#fff200" },
  { symbol: "Kr", row: 4, col: 18, color: "#f8a5c2" },

  // Add all remaining rows as per this pattern...
  // For brevity, only first few rows are shown.

  // Lanthanides (row 8)
  { symbol: "La", row: 8, col: 3, color: "#8cf58b" },
  { symbol: "Ce", row: 8, col: 4, color: "#8cf58b" },
  { symbol: "Pr", row: 8, col: 5, color: "#8cf58b" },
  { symbol: "Nd", row: 8, col: 6, color: "#8cf58b" },
  { symbol: "Pm", row: 8, col: 7, color: "#8cf58b" },
  { symbol: "Sm", row: 8, col: 8, color: "#8cf58b" },
  { symbol: "Eu", row: 8, col: 9, color: "#8cf58b" },
  { symbol: "Gd", row: 8, col: 10, color: "#8cf58b" },
  { symbol: "Tb", row: 8, col: 11, color: "#8cf58b" },
  { symbol: "Dy", row: 8, col: 12, color: "#8cf58b" },
  { symbol: "Ho", row: 8, col: 13, color: "#8cf58b" },
  { symbol: "Er", row: 8, col: 14, color: "#8cf58b" },
  { symbol: "Tm", row: 8, col: 15, color: "#8cf58b" },
  { symbol: "Yb", row: 8, col: 16, color: "#8cf58b" },
  { symbol: "Lu", row: 8, col: 17, color: "#8cf58b" },

  // Actinides (row 9)
  { symbol: "Ac", row: 9, col: 3, color: "#8cf58b" },
  { symbol: "Th", row: 9, col: 4, color: "#8cf58b" },
  { symbol: "Pa", row: 9, col: 5, color: "#8cf58b" },
  { symbol: "U", row: 9, col: 6, color: "#8cf58b" },
  { symbol: "Np", row: 9, col: 7, color: "#8cf58b" },
  { symbol: "Pu", row: 9, col: 8, color: "#8cf58b" },
  { symbol: "Am", row: 9, col: 9, color: "#8cf58b" },
  { symbol: "Cm", row: 9, col: 10, color: "#8cf58b" },
  { symbol: "Bk", row: 9, col: 11, color: "#8cf58b" },
  { symbol: "Cf", row: 9, col: 12, color: "#8cf58b" },
  { symbol: "Es", row: 9, col: 13, color: "#8cf58b" },
  { symbol: "Fm", row: 9, col: 14, color: "#8cf58b" },
  { symbol: "Md", row: 9, col: 15, color: "#8cf58b" },
  { symbol: "No", row: 9, col: 16, color: "#8cf58b" },
  { symbol: "Lr", row: 9, col: 17, color: "#8cf58b" },
];

const PeriodicTable = () => {
  const rows = 10;
  const cols = 18;

  return (
    <Grid container spacing={1} justifyContent="center">
      {[...Array(rows)].map((_, rowIdx) => (
        <Grid key={rowIdx} container item spacing={1} justifyContent="center">
          {[...Array(cols)].map((_, colIdx) => {
            const element = elements.find(
              (el) => el.row === rowIdx + 1 && el.col === colIdx + 1
            );
            return (
              <Grid key={colIdx} item>
                {element ? (
                  <ElementBox bgcolor={element.color}>
                    {element.symbol}
                  </ElementBox>
                ) : (
                  <div style={{ width: 60, height: 60 }} />
                )}
              </Grid>
            );
          })}
        </Grid>
      ))}
    </Grid>
  );
};

export default PeriodicTable;

// import { Box } from "@mui/material";
// import Lion from "./lion.png";
// import { colors as color } from "../../css components/Style";

// const polarToCartesian = (cx, cy, r, angleDeg) => {
//   const rad = (angleDeg * Math.PI) / 180;
//   return {
//     x: cx + r * Math.cos(rad),
//     y: cy + r * Math.sin(rad),
//   };
// };

// const describeArc = (cx, cy, r, startAngle, endAngle) => {
//   const start = polarToCartesian(cx, cy, r, startAngle);
//   const end = polarToCartesian(cx, cy, r, endAngle);
//   const largeArc = endAngle - startAngle > 180 ? 1 : 0;

//   return [
//     `M ${cx} ${cy}`,
//     `L ${start.x} ${start.y}`,
//     `A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`,
//     "Z",
//   ].join(" ");
// };

// export default function HalfDial({
//   activeIndexes,
//   setActiveIndexes,
//   segments,
//   setIncludedSegments,
// }) {
//   const cx = 320;
//   const cy = 320;
//   const baseRadius = 300;
//   const innerRadius = baseRadius - 140;

//   const colors = [
//     color.growthOSLightBlue,
//     color.growthOSLightBlue,
//     color.growthOSLightBlue,
//     color.growthOSLightBlue,
//   ];
//   const activeColors = ["#8a20ae", "#27a9af", "#f29524", "#ef5350"];

//   const handleToggle = (index, segments) => {
//     setIncludedSegments((prev) => {
//       let segment = [...prev];
//       if (
//         segment.findIndex(
//           (s) => parseInt(s.segmentID) === parseInt(segments.id)
//         ) !== -1
//       ) {
//         segment = segment.filter((i) => i.segmentID !== segments.id);
//       } else {
//         segment.push({
//           segmentID: segments.id,
//           segmentTitle: segments.segment_title,
//         });
//       }

//       return segment;
//     });

//     setActiveIndexes((prev) =>
//       prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
//     );
//   };

//   return (
//     <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
//       <svg width="640" height="310">
//         {[...Array(4)].map((_, index) => {
//           const startAngle = 180 + index * 45;
//           const endAngle = 180 + (index + 1) * 45;
//           const isActive = activeIndexes.includes(index);
//           const radius = isActive ? baseRadius + 18 : baseRadius;
//           const inner = radius - 140;

//           const path = describeArc(cx, cy, radius, startAngle, endAngle);

//           // Label positioning
//           const labelAngle = (startAngle + endAngle) / 2;
//           const baseLabelPos = polarToCartesian(
//             cx,
//             cy,
//             radius - 80,
//             labelAngle
//           );

//           // Right edge path
//           const outerEnd = polarToCartesian(cx, cy, radius, endAngle);
//           const innerEnd = polarToCartesian(cx, cy, inner, endAngle);
//           const rightEdgePath = `
//             M ${outerEnd.x} ${outerEnd.y}
//             L ${innerEnd.x} ${innerEnd.y}
//           `;

//           return (
//             <g key={index}>
//               {/* Arc */}
//               <path
//                 d={path}
//                 fill={isActive ? activeColors[index] : colors[index]}
//                 style={{
//                   cursor: "pointer",
//                   transition: "all 0.3s ease",
//                   pointerEvents:
//                     segments[index]?.segment_title === "Content" && "none",
//                 }}
//                 onClick={() => handleToggle(index, segments[index])}
//               />

//               {!isActive && (
//                 <path
//                   d={rightEdgePath}
//                   stroke={color.publicisBlue}
//                   strokeWidth={2}
//                 />
//               )}

//               <text
//                 x={baseLabelPos.x}
//                 y={baseLabelPos.y - 30}
//                 fill={isActive ? "#fff" : color.publicisBlue}
//                 fontSize="14"
//                 fontWeight="bold"
//                 textAnchor="middle"
//                 cursor={"pointer"}
//                 style={{
//                   pointerEvents:
//                     segments[index]?.segment_title === "Content" && "none",
//                 }}
//                 onClick={() => handleToggle(index, segments[index])}
//               >
//                 {segments[index]?.segment_title}
//               </text>

//               {segments[index]?.segment_desc?.map((line, i) => (
//                 <text
//                   key={i}
//                   x={baseLabelPos.x}
//                   y={baseLabelPos.y - 10 + i * 16}
//                   fill={isActive ? "#fff" : color.publicisBlue}
//                   fontSize="12"
//                   textAnchor="middle"
//                   cursor={"pointer"}
//                   style={{
//                     pointerEvents:
//                       segments[index]?.segment_title === "Content" && "none",
//                   }}
//                   onClick={() => handleToggle(index, segments[index])}
//                 >
//                   {line}
//                 </text>
//               ))}
//             </g>
//           );
//         })}

//         {/* Inner circle */}
//         <path d={describeArc(cx, cy, innerRadius, 180, 360)} fill={"#1048dd"} />

//         {/* Center text */}
//         {/* <text
//           x={cx}
//           y={cy - 100}
//           fill="white"
//           fontSize="20"
//           fontWeight="bold"
//           textAnchor="middle"
//         >
//           Identity
//         </text>
//         <text
//           x={cx}
//           y={cy - 70}
//           fill="#fff"
//           fontSize="16"
//           fontWeight="500"
//           textAnchor="middle"
//         >
//           590M+ Indian Unique IDs
//         </text>
//         <text x={cx} y={cy - 40} fill="#fff" fontSize="12" textAnchor="middle">
//           Data-Powered Audience Precision Intelligence
//         </text> */}
//         <image
//           href={Lion}
//           x={cx - 120}
//           y={cy - 171} // move image up
//           width="240"
//           height="180"
//         />
//       </svg>

//       <Box
//         mt={"7px"}
//         width={"94%"}
//         bgcolor={color.publicisBlue}
//         textAlign="center"
//         py={1.5}
//         fontWeight="bold"
//         color="#fff"
//         fontSize="14px"
//         padding={"10px"}
//       >
//         {/* 60+ Data Partners . 140+ Data Fields . 1800+ Attributes */}
//       </Box>
//     </Box>
//   );
// }
